import SEO from '../components/SEO/SEO'
import Hero from '../components/Hero'
import Services from '../components/Services'
import AssessmentCTA from '../components/AssessmentCTA'
import WhyFigo from '../components/WhyFigo'
import SalesDeck from '../components/SalesDeck'
// import Packages from '../components/Packages'
// import Clients from '../components/Clients'
// import CaseStudy from '../components/CaseStudy'
import Blog from '../components/Blog'
import FAQ from '../components/FAQ'
import CTA from '../components/CTA'

const HomePage = () => {
  return (
    <div className="home-page">
      <SEO
        title="FIGO Digital Services - Custom Software Development & Digital Transformation in Nigeria"
        description="Leading digital transformation agency in Nigeria. We build custom software, AI automation, mobile apps, and provide complete digital solutions for businesses in Abuja, Lagos & globally."
        keywords="software development Nigeria, digital transformation, AI automation, custom software, mobile app development, web development, fintech solutions, Abuja software company, Lagos tech agency, business automation Nigeria"
        url="https://figodigitalservices.com"
      />
      <Hero />
      <Services />
      <AssessmentCTA />
      <WhyFigo />
      <SalesDeck />
      {/* <Packages /> */}
      {/* <Clients /> */}
      {/* <CaseStudy /> */}
      <Blog />
      <FAQ />
      <CTA />
    </div>
  )
}

export default HomePage
